import { getRenderTimeZone } from "@clockwise/web-commons/src/util/time-zone.util";
import { DateTime, Interval } from "luxon";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { clearSelectedRescheduleOption } from "../../state/actions/reschedule-event-modal.actions";
import { IReduxState } from "../../state/reducers/root.reducer";
import { RescheduleEventGatewayMutation } from "../hooks/__generated__/RescheduleEventGateway.v2.generated";
import { useRescheduleEvent } from "../hooks/useRescheduleEvent";
import { RescheduleConfirmationModal } from "./RescheduleConfirmationModal";

export const RescheduleConfirmationWrapper = () => {
  const selectedSchedulingOption = useSelector(
    (state: IReduxState) => state.rescheduleEventModal.selectedRescheduleOption,
  );

  const timeZone = getRenderTimeZone();
  const dispatch = useDispatch();
  const { rescheduleEvent } = useRescheduleEvent(() => rescheduleCallback());
  const [isModalOpen, setIsModalOpen] = React.useState(true);

  const onClose = () => {
    dispatch(clearSelectedRescheduleOption());
    setIsModalOpen(false);
  };

  const rescheduleCallback = () => {
    toast.success("Event rescheduled");
    onClose();
  };

  const onSave = (externalEventId: string, start: string) => {
    if (selectedSchedulingOption) {
      const optimisticResponse: RescheduleEventGatewayMutation = {
        __typename: "Mutation",
        rescheduleEvent: {
          __typename: "Event",
          id: selectedSchedulingOption.id ?? "",
          externalEventId,
          title: selectedSchedulingOption.title,
          dateOrTimeRange: {
            __typename: "DateTimeRange",
            timeRange: Interval.fromDateTimes(
              DateTime.fromISO(start),
              DateTime.fromISO(start).plus({ minutes: selectedSchedulingOption.duration }),
            ).toISO(),
          },
        },
      };
      rescheduleEvent(externalEventId, start, timeZone, optimisticResponse);
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    if (selectedSchedulingOption) {
      setIsModalOpen(true);
    }
  }, [selectedSchedulingOption]);

  return selectedSchedulingOption ? (
    <RescheduleConfirmationModal
      isOpen={isModalOpen}
      title={selectedSchedulingOption.title}
      externalEventId={selectedSchedulingOption.externalEventId}
      onClose={onClose}
      proposedStart={selectedSchedulingOption.proposedStartTimeISO}
      duration={selectedSchedulingOption.duration}
      existingStart={selectedSchedulingOption.currentStartTimeISO}
      onSave={onSave}
    />
  ) : null;
};
